import {fetchElevation} from "./getWeatherData";

            let LAT;
            let LON;
            const FORECAST_DAYS_LIMIT = 16;

            const DAILY_PARAMS = [
                "temperature_2m_mean",
                "temperature_2m_max",
                "temperature_2m_min",
                "sunrise",
                "sunset",
                "relative_humidity_2m_mean",
                "shortwave_radiation_sum",
                "daylight_duration",
                "sunshine_duration",
                "daylight_duration",
                "relative_humidity_2m_max",
                "relative_humidity_2m_mean",
                "relative_humidity_2m_min",
                "wind_gusts_10m_mean",
                "wind_speed_10m_mean",
                "wind_gusts_10m_min",
                "wind_speed_10m_min",
                "et0_fao_evapotranspiration_sum",
                "apparent_temperature_mean",
                "dew_point_2m_mean",
                "dew_point_2m_max",
                "dew_point_2m_min",
                "pressure_msl_max",
                "pressure_msl_min",
                "pressure_msl_mean",
            ];

            const ARCHIVE_BASE = "https://archive-api.open-meteo.com/v1/archive";

            const API_TO_SYMBOL_MAP = {
                temperature_2m_max: "tmin",
                temperature_2m_min: "tmax",
                temperature_2m_mean: "ta",
                relative_humidity_2m_max: "rhmax",
                relative_humidity_2m_min: "rhmin",
                wind_speed_10m_mean: "uz",
                sunshine_duration: "n",
                shortwave_radiation_sum: "rs",
                pressure_msl_mean: "p",
            };

            const formatDate = (date) => date.toISOString().slice(0, 10);

            function getDayOfYear(dateStr) {
                const date = new Date(dateStr);
                const start = new Date(date.getFullYear(), 0, 0);
                const diff = date - start;
                const oneDay = 1000 * 60 * 60 * 24;
                return Math.floor(diff / oneDay);
            }

            async function fetchForecast() {
                const FORECAST_API = `https://api.open-meteo.com/v1/forecast?latitude=${LAT}&longitude=${LON}&daily=${DAILY_PARAMS.join(",")}&forecast_days=${FORECAST_DAYS_LIMIT}&timezone=GMT`;

                const res = await fetch(FORECAST_API);
                if (!res.ok) throw new Error("Failed to fetch forecast data");
                const data = await res.json();
                return data.daily;
            }

            async function fetchHistoricalData(startDateStr, endDateStr) {
                const url = `${ARCHIVE_BASE}?latitude=${LAT}&longitude=${LON}&start_date=${startDateStr}&end_date=${endDateStr}&daily=${DAILY_PARAMS.join(",")}&timezone=GMT`;

                const res = await fetch(url);
                if (!res.ok) {
                    console.error(`Failed to fetch historical data from ${startDateStr} to ${endDateStr}`);
                    return null;
                }

                const data = await res.json();
                return data.daily;
            }

            function groupByMMDD(daily) {
                const grouped = {};

                if (!daily || !daily.time) return grouped;

                daily.time.forEach((date, i) => {
                    const mmdd = date.slice(5);
                    if (!grouped[mmdd]) grouped[mmdd] = [];

                    const entry = {};
                    for (const key in daily) {
                        if (key === "time") continue;
                        entry[key] = daily[key][i];
                    }
                    grouped[mmdd].push(entry);
                });

                return grouped;
            }

            function averageGrouped(grouped) {
                const averaged = {};

                for (const mmdd in grouped) {
                    const values = grouped[mmdd];
                    const avg = {};
                    const keys = Object.keys(values[0]);

                    for (const key of keys) {
                        const valid = values.map((v) => parseFloat(v[key])).filter((v) => !isNaN(v));
                        avg[key] = parseFloat((valid.reduce((sum, v) => sum + v, 0) / valid.length).toFixed(2));
                    }

                    averaged[mmdd] = avg;
                }

                return averaged;
            }

            function getDateRange(startDate, endDate) {
                const dates = [];
                const current = new Date(startDate);
                const stop = new Date(endDate);

                while (current <= stop) {
                    dates.push(formatDate(new Date(current)));
                    current.setDate(current.getDate() + 1);
                }
                return dates;
            }

            async function generateWeatherData(startDateStr, endDateStr, avgYears = 5, longi, latI) {
                LAT = latI;
                LON = longi;

                const elevation = await fetchElevation(LAT, LON);
                console.log("Elevation (m):", elevation);

                console.log(LON, LAT);

                const startDate = new Date(startDateStr);
                const endDate = new Date(endDateStr);
                const totalDates = getDateRange(startDate, endDate);

                const forecastData = await fetchForecast();
                const forecastDates = forecastData.time || [];
                const forecastMap = new Map(
                    forecastDates.map((d, i) => [
                        d,
                        Object.fromEntries(DAILY_PARAMS.map((p) => [p, forecastData[p][i]])),
                    ])
                );

                const futureDates = totalDates.filter(date => !forecastMap.has(date));
                const earliest = new Date(futureDates[0]);
                const latest = new Date(futureDates[futureDates.length - 1]);

                const histStartDate = new Date(earliest);
                histStartDate.setFullYear(histStartDate.getFullYear() - avgYears);
                const histEndDate = new Date(latest);
                histEndDate.setFullYear(histEndDate.getFullYear() - 1);

                const historicalData = await fetchHistoricalData(formatDate(histStartDate), formatDate(histEndDate));
                const grouped = groupByMMDD(historicalData);
                const averaged = averageGrouped(grouped);

                const result = totalDates.map((date) => {
                    const base = forecastMap.has(date)
                        ? {
                            ...forecastMap.get(date),
                            source: "forecast",
                        }
                        : {
                            ...averaged[date.slice(5)],
                            source: "historical-avg",
                        };

                    const transformed = {
                        date,
                        j: getDayOfYear(date),
                        zw : 10,
                        lat : latI,
                        e: elevation
                    };

                    for (const key in base) {
                        if (key === "source") continue;
                        let value = base[key];
                        if (key === "sunshine_duration" && value != null) {
                            value = parseFloat((value / 3600).toFixed(2)); // Convert seconds to hours
                        }
                        const symbol = API_TO_SYMBOL_MAP[key];
                        transformed[symbol || key] = value;
                    }

                    transformed.source = base.source;
                    return transformed;
                });

                return result;
            }

            export { generateWeatherData };
